'use client';

import React from 'react';
import { useSelectedLayoutSegment } from 'next/navigation';
import { ComponentProps } from 'react';
import { Link as MuiLink } from '@unity/cloud-ui';
import { Link } from '@/i18n/routing';
import { createScopedLink } from '@/utils/create-scoped-link';
import { NavigationProgress } from '../navigation-progress/navigation-progress';
import { useOrigin } from '../request-provider/request-provider';

export function NavigationLink({ href, children, ...rest }: ComponentProps<typeof MuiLink>) {
  const origin = useOrigin();
  const finalHref = createScopedLink(href ?? '', origin);

  const selectedLayoutSegment = useSelectedLayoutSegment();
  const pathname = selectedLayoutSegment ? `/${selectedLayoutSegment}` : '/';
  if (!href) {
    return <React.Fragment>{children}</React.Fragment>;
  }
  const isActive = pathname === href;

  return (
    <MuiLink component={Link} aria-current={isActive ? 'page' : undefined} href={finalHref} {...rest}>
      <NavigationProgress />
      {children}
    </MuiLink>
  );
}
